import { render, staticRenderFns } from "./Inspection.vue?vue&type=template&id=5a003887&"
import script from "./Inspection.vue?vue&type=script&lang=ts&"
export * from "./Inspection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports